import { LANGUAGE } from "@utils/constants";

const time_formats = [
  [60, "s", 1], // 60
  [120, "1min ago", "1 minute from now"], // 60*2
  [3600, "min", 60], // 60*60, 60
  [7200, "1h ago", "1 hour from now"], // 60*60*2
  [86400, "h", 3600], // 60*60*24, 60*60
  [172800, "1d ago", "Tomorrow"], // 60*60*24*2
  [604800, "d", 86400], // 60*60*24*7, 60*60*24
  [1209600, "1w ago", "Next week"], // 60*60*24*7*4*2
  [2419200, "w", 604800], // 60*60*24*7*4, 60*60*24*7
  [4838400, "1 month", "Next month"], // 60*60*24*7*4*2
  [29030400, " months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
  [58060800, "1y", "Next year"], // 60*60*24*7*4*12*2
  [2903040000, "y", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
  [5806080000, "1 century", "Next century"], // 60*60*24*7*4*12*100*2
  [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
];

function time_ago(time) {
  const currentTimestamp = Date.now();
  let seconds = Math.floor((currentTimestamp - parseInt(time)) / 1000);
  let list_choice = 1;

  if (seconds <= 60) {
    return "Just now";
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    list_choice = 2;
  }
  var i = 0,
    format;
  while ((format = time_formats[i++]))
    if (seconds < format[0]) {
      if (typeof format[2] == "string") return format[list_choice];
      else return Math.floor(seconds / format[2]) + format[1] + " ago";
    }
  return time;
}

function prettyDate(date, lang) {
  if (lang === LANGUAGE.HINDI) {
    return date.toLocaleDateString("hi-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } else {
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }
}

function prettyDateDay(date, lang) {
  if (lang === LANGUAGE.HINDI) {
    return date.toLocaleDateString("hi-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } else {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }
}

function formatNumber(num) {
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "k+";
  }
  return num + "k+";
}

function formatNumberInWords(num) {
  if (num >= 100000) {
    return (num / 100000).toFixed(0) + " Lakh+";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(0) + " Thousands+";
  }
  return num;
}

function readingTime(text) {
  // const text = document.getElementById("article").innerText;
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const time = Math.ceil(words / wpm);
  return time;
}

function dateFormat(time) {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const getDate = time.split("T")[0];
  const getCDate = getDate.split("-")[2];
  const getTempMoth = getDate.split("-")[1];
  const getCMonth = months[getTempMoth.split("0")[1] - 1];
  const getCYear = getDate.split("-")[0];

  switch (getCDate.charAt(getCDate.length - 1)) {
    case "1":
      return `${getCDate}st ${getCMonth}, ${getCYear}`;
    case "2":
      return `${getCDate}nd ${getCMonth}, ${getCYear}`;
    case "3":
      return `${getCDate}rd ${getCMonth}, ${getCYear}`;
    default:
      return `${getCDate}th ${getCMonth}, ${getCYear}`;
  }
}

function getTimeForStatus(tempTime) {
  const getTs = new Date(Number(tempTime));

  var monthsL = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = getTs.getDate();
  const month = monthsL[getTs.getMonth()];
  const year = getTs.getFullYear();

  return `${date} ${month} ${year}`;
}

function timeConverter(timestamp, lang = LANGUAGE.ENGLISH) {
  // Convert the timestamp to milliseconds (if it's not already in milliseconds)
  const milliseconds = Number(timestamp);

  // Check if the conversion is valid
  if (!isNaN(milliseconds)) {
    // Add 2 days to the timestamp (2 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
    // const futureDate = new Date(milliseconds + 2 * 24 * 60 * 60 * 1000);
    const date = new Date(milliseconds);

    // Format the date string (e.g., "30 Apr 2024")
    if (lang === LANGUAGE.HINDI) {
      const formattedDate = date.toLocaleDateString("hi-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return formattedDate;
    } else {
      const formattedDate = date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return formattedDate;
    }
  } else {
    // Return an error message if the timestamp is invalid
    return "Invalid timestamp";
  }
}

export {
  time_ago,
  prettyDate,
  prettyDateDay,
  readingTime,
  dateFormat,
  getTimeForStatus,
  formatNumber,
  timeConverter,
  formatNumberInWords,
};
